/**
 * deployment-menu-item.js
 */

import React from 'react';
import { Typography, Chip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { format, parseISO } from 'date-fns';
import DrawerMenuItem from 'components/menu-drawer/menu/drawer-menu-item';


const useStyles = makeStyles(theme => ({
  container: {
    justifyContent: 'space-between'
  },
  title: {
    fontSize: theme.typography.sizes[1],
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  sub: {
    fontSize: theme.typography.sizes[1]
  },
  chip: {
    border: `1px solid ${theme.palette.grey.colors[7]}`,
  },
  incomplete: {
    color: theme.palette.grey.colors[2],
    backgroundColor: theme.palette.grey.colors[8],
  },
}));


export default function DeploymentMenuItem(props) {
  const {
    record,
    to,
    hideChevron
  } = props;
  const classes = useStyles();


  const completionChip = () => {
    let label = '';
    let className = '';

    if (record.isComplete) {
      label = 'Complete';
      className = 'chip-complete chip-font-complete';
    } else {
      label = 'Incomplete';
      className = 'chip-incomplete chip-font-incomplete';
    }

    return (
      <Chip
        label={label}
        size="small"
        className={`${classes.chip} ${className}`}
      />
    )
  }


  const label = () => {
    return (
      <div className={`flex-hc ${classes.container}`}>
        <div style={{ overflow: 'hidden' }}>
          <div className='flex-hc'>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {/* name */}
              <Typography
                variant="body2"
                className={classes.title}
              >
                Case: {record.caseNumber}
              </Typography>

              {/* date */}
              <Typography
                variant="body2"
                className={classes.sub}
              >
                {format(parseISO(record.date), 'MMM dd, yyyy h:mm aaa')}
              </Typography>

              {/* location */}
              {record.location &&
              <Typography
                variant="body2"
                className={classes.sub}
              >
                {record.location.locationName || record.location.address1}
              </Typography>}

            </div>
          </div>
        </div>

        {/* completion chip */}
        <div>
          {completionChip()}
        </div>
      </div>
    );
  }


  return (
    <>
      {record &&
        <>
          <DrawerMenuItem
            id={`deployment-${record.id}`}
            iconName='deployment'
            label={label()}
            to={to}
            hideChevron={hideChevron}
            noBGHover
          />
        </>}
    </>
  );
}